import { Contact } from '@features/contacts/types/contact'

import { BillFormLineKeys } from './formData'

export type GetShouldOverridenParamChange = (args: GetShouldOverridenParamChangeInnerProps) => boolean

export interface GetShouldOverridenParamChangeInnerProps {
  property: BillFormLineKeys
  propertiesLocked?: boolean
  hasValueOverriden: boolean
  vendor: Partial<Contact> | undefined
}

export const getShouldOverridenParamChange = ({
  property,
  propertiesLocked,
  hasValueOverriden,
  vendor,
}: GetShouldOverridenParamChangeInnerProps): boolean => {
  // VAT-related properties should not be rewriten to empty if already filled
  if (property === 'vatAmount' || property === 'inclVatAmount') {
    return hasValueOverriden
  }

  // propertiesLocked can only be truthy from vendor change
  // only taxRate and expenseCategory can be locked
  // we only consider property to be locked if vendor has default set
  if (property === 'expenseCategory') {
    return !vendor?.defaultExpenseAccountId || !propertiesLocked
  }

  if (property === 'taxRate') {
    return !vendor?.defaultTaxRateId || !propertiesLocked
  }

  return true
}
